import { DepartureSecuredStatus } from '@flashpack/graphql';

export const securedStatusLabel = (securedStatus: DepartureSecuredStatus) => {
  switch (securedStatus) {
    case DepartureSecuredStatus.Pending:
      return 'Secured?';
    case DepartureSecuredStatus.CostSecured:
      return 'Cost secured';
    case DepartureSecuredStatus.AllocationSecured:
      return 'Allocation secured';
    case DepartureSecuredStatus.NotSecured:
      return 'Not secured';
    default:
      return securedStatus;
  }
};
